var REACT_ELEMENT_TYPE;function _jsx(type, props, key, children) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var defaultProps = type && type.defaultProps,childrenLength = arguments.length - 3;if (props || 0 === childrenLength || (props = { children: void 0 }), 1 === childrenLength) props.children = children;else if (childrenLength > 1) {for (var childArray = new Array(childrenLength), i = 0; i < childrenLength; i++) childArray[i] = arguments[i + 3];props.children = childArray;}if (props && defaultProps) for (var propName in defaultProps) void 0 === props[propName] && (props[propName] = defaultProps[propName]);else props || (props = defaultProps || {});return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: void 0 === key ? null : "" + key, ref: null, props: props, _owner: null };}import * as Cookie from 'tiny-cookie';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { isClient } from "../utils";
import { Translate } from "../I18N";

import { Notification } from "../Notifications/components/Notification";

export class Cookiepopup extends Component {
  constructor(props) {
    super(props);
    this.state = { cookieExists: !isClient || isClient && Boolean(Cookie.get('cookiepolicy')) };
    this.close = this.close.bind(this);
  }

  close() {
    Cookie.set('cookiepolicy', 1, { expires: 365 * 10 });
    this.setState({ cookieExists: true });
  }

  render() {
    const { cookiepolicy } = this.props;
    const { cookieExists } = this.state;
    if (!cookiepolicy || cookieExists) {
      return /*#__PURE__*/_jsx("div", { className: "alert-wrapper" });
    }

    const message = /*#__PURE__*/
    _jsx(Translate, {}, void 0, "To bring you a better experience, this site uses cookies.");

    return /*#__PURE__*/(
      _jsx("div", { className: "alert-wrapper" }, void 0, /*#__PURE__*/
      _jsx(Notification, { id: "cookiepolicy", removeNotification: this.close, message: message })));


  }
}





const mapStateToProps = (state) => ({
  cookiepolicy: Boolean(state.settings.collection.get('cookiepolicy'))
});

export default connect(mapStateToProps)(Cookiepopup);